export default __webpack_public_path__ + "static/media/(32).660d7110.jpg";